/* eslint-disable */
import * as am5 from '@amcharts/amcharts5';
import * as am5map from '@amcharts/amcharts5/map';
import am5ThemesAnimated from '@amcharts/amcharts5/themes/Animated';
import am5GeodataWorldLow from '@amcharts/amcharts5-geodata/worldLow';

window.customElements.define(
  'e-map',
  class extends HTMLElement {
    constructor() {
      super();
      this.currentCountry = '';
      this.branches = document.querySelector('.contact-country[data-default]');
      this.countries = document.querySelectorAll(
        '.contact-country:not([data-default])',
      );
      this.inputCountry = document.querySelector('.contact-filter-country');
      this.inputZip = document.querySelector('.contact-filter-zip');
      this.inputProduct = document.querySelector('.contact-filter-product');
      this.inputCountry.value = '';
      this.inputProduct.value = '';
      this.inputZip.value = '';
      this.createMap();
      this.createCountryFilter();
      this.inputProduct.addEventListener('change', () => this.filterContacts());
      this.inputZip.addEventListener('change', () => this.filterContacts());
      document.querySelectorAll('.contact-btn-email').forEach((button) => {
        button.addEventListener('click', (e) => {
          if (e.target.dataset.contactInput
                        && e.target.dataset.contactId
                        && document.querySelector(e.target.dataset.contactInput)) {
            e.preventDefault();
            const input = document.querySelector(e.target.dataset.contactInput);
            input.value = e.target.dataset.contactId;
            input.form.closest('.container').scrollIntoView();
          }
        });
      });
      this.smoothScroll();
    }

    createCountryFilter() {
      this.countries.forEach((item) => {
        this.inputCountry.insertAdjacentHTML(
          'beforeend',
          `<option value="${item.dataset.twoletters}">${item.dataset.label}</option>`,
        );
      });
      this.inputCountry.addEventListener('change', () => {
        this.toggleCountry(this.inputCountry.value);
      });

      if (this.countries.length == 1) {
        this.toggleCountry(this.countries[0].dataset.twoletters);
        // disable first option in select if only one country
        this.inputCountry.querySelector('option').disabled = true;
        this.inputCountry.querySelector('option').selected = false;

        // klappt das nicht? dly ma
        //this.inputCountry.querySelectorAll('option')[1].selected = true;
        //this.inputCountry.value = this.countries[0].dataset.twoletters;
      }
    }

    toggleCountry(twoLetters) {
      this.countries.forEach((country) => country.classList.add('d-none'));
      this.amPolygonSeries.mapPolygons.each((poly) => poly.dataItem.dataContext.id !== twoLetters && poly.set('active', false));
      this.inputProduct.value = '';
      this.inputZip.value = '';
      if (!twoLetters) {
        this.currentCountry = '';
        this.inputCountry.value = '';
        if (this.branches) {
          this.branches.classList.remove('d-none');
        }
        this.toggleFilter();
        return;
      }
      const targetPoly = this.amPolygonSeries.mapPolygons.values
        .find((item) => item.dataItem.dataContext.id === twoLetters);
      this.currentCountry = [...this.countries]
        .find((country) => country.dataset.twoletters === twoLetters);
      this.currentCountry.countryItems = [...this.currentCountry.querySelectorAll('.contact-country-item')];
      targetPoly.set('active', true);
      this.currentCountry.classList.remove('d-none');
      if (this.branches) {
        this.branches.classList.add('d-none');
      }
      this.inputCountry.value = twoLetters;
      this.toggleFilter();
    }

    toggleFilter() {
      if (!this.currentCountry) {
        this.inputProduct.classList.add('d-none');
        this.inputZip.classList.add('d-none');
        return;
      }
      const contacts = this.currentCountry.countryItems;
      contacts.forEach((item) => item.classList.remove('d-none'));
      this.inputProduct.classList.toggle('d-none', ![...contacts].some((item) => item.dataset.products));
      this.inputZip.classList.toggle('d-none', ![...contacts].some((item) => item.dataset.ziprange));
    }

    filterContacts() {
      const contacts = this.currentCountry.countryItems;
      if (!this.inputProduct.value && !this.inputZip.value) {
        contacts.forEach((contact) => contact.classList.remove('d-none'));
        return;
      }
      contacts.forEach((contact) => {
        let isGood = true;
        if (this.inputProduct.value && contact.dataset.products && !contact.dataset.products.split(',').includes(this.inputProduct.value)) {
          isGood = false;
        }
        if (this.inputZip.value.length >= 2 && contact.dataset.ziprange) {
          const zips = contact.dataset.ziprange.split(',');
          // check if array of zips in this.inputZip.value
          // iterate zips and regex match
          let found = false;
          zips.forEach((zip) => { if (new RegExp(`^${zip}`).test(this.inputZip.value)) found = true; });
          isGood = found;
        }
        contact.classList.toggle('d-none', !isGood);
      });
    }

    createMap() {
      const root = am5.Root.new(this);
      root.setThemes([am5ThemesAnimated.new(root)]);
      this.amChart = root.container.children.push(
        am5map.MapChart.new(root, {
          rotationX: -10,
          panX: 'translateX',
          panY: 'translateY',
          wheelX: 'none',
          wheelY: 'none',
          projection: am5map.geoMercator(),
        }),
      );
      this.amChart.chartContainer.get('background').events.on('click', () => {
        this.amChart.goHome();
      });

      // Create polygon series
      this.amPolygonSeries = this.amChart.series.push(
        am5map.MapPolygonSeries.new(root, {
          geoJSON: am5GeodataWorldLow,
          exclude: ['AQ'],
        }),
      );

      this.amPolygonSeries.mapPolygons.template.setAll({
        active: false,
        fill: am5.color(0xffffff),
        stroke: am5.color(0x012a3d),
        fillOpacity: 0.4,
        templateField: 'polygonSettings',
      });

      this.amPolygonSeries.mapPolygons.template.states.create('hover', {
        fill: am5.color('#dddddd'),
      });

      this.amPolygonSeries.mapPolygons.template.states.create('active', {
        fill: am5.color('#008FA2'),
      });

      this.amPolygonSeries.mapPolygons.template.on('active', (active, target) => {
        if (target.dataItem) {
          this.toggleCountry(target.get('active') ? target.dataItem.dataContext.id : '');
        }
      });

      const polyCountryData = [...this.countries].map((country) => ({
        id: country.dataset.twoletters,
        name: country.dataset.label,
        polygonSettings: {
          tooltipText: '{name}',
          interactive: true,
          toggleKey: 'active',
          fill: am5.color(0xffffff),
          fillOpacity: 1,
        },
      }));
      this.amPolygonSeries.data.setAll(polyCountryData);

      const zoomControl = this.amChart.set(
        'zoomControl',
        am5map.ZoomControl.new(root, {}),
      );

      [zoomControl.minusButton, zoomControl.plusButton].forEach((button) => {
        button.get('background').setAll({
          cornerRadiusTL: 0,
          cornerRadiusTR: 0,
          cornerRadiusBR: 0,
          cornerRadiusBL: 0,
          fill: am5.color(0xe6eaf0),
          strokeWidth: 0,
          strokeOpacity: 0,
        });
        button.get('icon').setAll({
          stroke: am5.color(0x012a3d),
          strokeWidth: 2,
        });
        button
          .get('background')
          .states.create('hover', {})
          .setAll({
            fill: am5.color(0xc7c7c7),
            fillOpacity: 1,
            strokeWidth: 0,
          });
        button
          .get('background')
          .states.create('down', {})
          .setAll({
            fill: am5.color(0xc7c7c7),
            fillOpacity: 1,
            strokeWidth: 0,
          });
      });

      // Set clicking on "water" to zoom out
      this.amChart.appear(1000, 100);
    }

    smoothScroll() {
      // scroll to form if #js_form is set as window.location.hash
      if (window.location.hash === '#js_form') {
        if (document.querySelector('form')) {
          window.setTimeout(() => {
            document.querySelector('form').closest('section').scrollIntoView({ behavior: 'smooth' });
          }, 200);
        }
      }
    }
  },
);
